import Locales from './locales';

function initCookieBanner() {
    const promoPanel = $('.wg-header__promo-panel').wgInstance();

    if (!promoPanel) {
        return;
    }

    if (!('strings' in window && 'headerCookieText' in window.strings)) {
        return;
    }

    return promoPanel.addBanner({
        name: 'cookie',
        cookie: 'topPanelHidden',
        priority: 90,
        text: 'text',
        content: window.strings.headerCookieText
    });
}

function main() {
    const userLocale = Locales.getUserLocale();
    const isEurope = Locales.checkEurope(userLocale);
    const isGdprVisitor = WG.utils.isEuVisitor(); // gdpr-popup are showing for these visitors

    if (isGdprVisitor || !isEurope) {
        return;
    }

    // initCookieBanner();
}

$(main);



// WEBPACK FOOTER //
// ./assets/js/common/modules/cookie-banner.js